export default {"componentDescription":"","propDescriptions":{"styles":{"description":"The styles you want to apply globally."}},"classDescriptions":{}};